import React from 'react';
import { StyleProp, ViewStyle, View } from 'react-native';
import Svg, { Rect, Path } from 'react-native-svg';

const DivideIconV2 = React.memo(
  (props: {
    width?: number;
    height?: number;
    color?: string;
    containerStyle?: StyleProp<ViewStyle>;
  }) => {
    return (
      <View style={props.containerStyle}>
        <Svg
          width={props.width ?? 42}
          height={props.height ?? 40}
          viewBox="0 0 42 40"
          fill="none"
          {...props}
        >
          <Rect
            x="0.617188"
            y="0.787109"
            width="41"
            height="39"
            rx="8"
            fill="white"
            fillOpacity="0.85"
          />
          <Path
            d="M21.1165 32.8934C19.1324 32.8934 17.6558 31.5231 17.6558 29.6047C17.6558 27.6862 19.1324 26.3159 21.1165 26.3159C23.1468 26.3159 24.5772 27.6862 24.5772 29.6047C24.5772 31.5231 23.1468 32.8934 21.1165 32.8934ZM10.7344 17.4546H31.4986V22.7074H10.7344V17.4546ZM21.1165 14.2572C19.1324 14.2572 17.6558 12.8869 17.6558 10.9684C17.6558 9.05 19.1324 7.67969 21.1165 7.67969C23.1468 7.67969 24.5772 9.05 24.5772 10.9684C24.5772 12.8869 23.1468 14.2572 21.1165 14.2572Z"
            fill={props.color ?? '#E2753A'}
          />
        </Svg>
      </View>
    );
  },
);

export { DivideIconV2 };
